import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {AutentictionApi} from '@/sdk/api-services';
import {PasswordResetConfirmModel} from '@/sdk/models';
import {Component} from 'vue-property-decorator';

@Component
export default class ResetPasswordComponent extends VueWrapper {
    public resetToken: string = '';
    public newPassword: string = '';
    public confirmNewPassword: string = '';

    public showNewPassword: boolean = false;
    public showConfirmPassword: boolean = false;

    public authenticationApi: AutentictionApi = new AutentictionApi();

    public created() {
        this.resetToken = (this.$route.query.token as string) ?? '';

        if (!this.resetToken) {
            this.AlertSrv.show('error', 'Missing reset session. Please verify your phone again.').then(() => {
                this.$router.push({name: 'forgotPassword'});
            });
        }
    }

    public async updatePassword() {
        if (!this.newPassword || !this.confirmNewPassword) {
            this.AlertSrv.show('error', 'Please provide both password fields.');
            return;
        }

        if (this.newPassword !== this.confirmNewPassword) {
            this.AlertSrv.show('error', 'Passwords do not match.');
            return;
        }

        try {
            this.LoaderSrv.showFullScreenLoader('Updating password...');
            const payload = new PasswordResetConfirmModel({
                resetToken: this.resetToken,
                newPassword: this.newPassword,
                confirmNewPassword: this.confirmNewPassword,
            });

            await this.authenticationApi.ConfirmPasswordReset(payload);
            this.AlertSrv.show('success', 'Password reset successful. Please sign in.').then(() => {
                this.$router.push({name: 'signin'});
            });
        } catch (err: any) {
            this.AlertSrv.show('error', err?.error?.message ?? 'Unable to reset password.');
        } finally {
            this.LoaderSrv.hideFullScreenLoader();
        }
    }

    public goBack() {
        this.$router.push({name: 'forgotPassword'});
    }
}
